import { UPDATE_PROMO_CODE } from "../constants/actionTypes";

export const updatePromoCode = code => ({
  type: UPDATE_PROMO_CODE,
  payload: code
});



// WEBPACK FOOTER //
// ./src/actions/promoCodeActions.js